import './landing.css';
import { LandingChart } from './LandingChart';
import type { MouseEventHandler } from 'react';

export default function Landing({
  onEnterApp,
}: {
  onEnterApp?: MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <div className="arena-app landing-page">
      <LandingChart />
      <header className="top-bar landing-header">
        <div className="landing-header-actions">
          <a
            className="identity-pill landing-primary landing-login"
            href="/app"
            onClick={onEnterApp}
          >
            Login
          </a>
        </div>
      </header>
      <main className="landing-main" aria-label="Run or Die">
        <div className="landing-hero">
          <h1 className="landing-title">runordie</h1>
        </div>
        <a
          className="identity-pill landing-primary landing-start"
          href="/app"
          onClick={onEnterApp}
        >
          Start predicting
        </a>
      </main>
    </div>
  );
}
